import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Box, Typography } from '@mui/material';
import { CategoryStat } from '../../types';

// Chart.jsの登録
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface BarChartProps {
  sortedCategoryStats: Array<{ category: string; stats: CategoryStat }>;
}

const BarChart: React.FC<BarChartProps> = ({ sortedCategoryStats }) => {
  // ラベルとデータの準備（工程別表示対応）
  const labels: string[] = [];
  const dataValues: number[] = [];
  const backgroundColors: string[] = [];

  let currentMainCategory = '';

  sortedCategoryStats.forEach(({ category, stats }) => {
    if (category.startsWith('成果物-')) {
      // 成果物カテゴリの場合
      if (currentMainCategory !== '成果物') {
        // 最初の成果物の場合、親カテゴリを追加
        labels.push('成果物');
        dataValues.push(0); // ダミーデータ
        backgroundColors.push('rgba(76, 175, 80, 0.3)');
        currentMainCategory = '成果物';
      }
      // 工程名のみ表示
      const processName = category.substring(4); // '成果物-'を除去
      labels.push(`  ${processName}`); // インデント
      dataValues.push(stats.average);
      backgroundColors.push('rgba(76, 175, 80, 0.6)');
    } else {
      // 通常のカテゴリ
      currentMainCategory = category;
      labels.push(category);
      dataValues.push(stats.average);
      backgroundColors.push('rgba(76, 175, 80, 0.8)');
    }
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: 'スキルレベル平均',
        data: dataValues,
        backgroundColor: backgroundColors,
        borderColor: 'rgba(76, 175, 80, 1)',
        borderWidth: 1
      }
    ]
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const value = context.parsed.x;
            return value > 0 ? `スキルレベル: ${value.toFixed(1)}/5.0` : '';
          }
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 5,
        ticks: {
          stepSize: 1
        },
        title: {
          display: true,
          text: 'スキルレベル平均'
        }
      },
      y: {
        ticks: {
          font: {
            size: 11
          }
        }
      }
    }
  };

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <Typography variant="h6" gutterBottom>
        カテゴリ別スキルレベル
      </Typography>
      <Bar data={chartData} options={options} />
    </Box>
  );
};

export default BarChart;
